import { render } from "./filterPrice.vue?vue&type=template&id=30b8e467"
import script from "./filterPrice.vue?vue&type=script&lang=js"
export * from "./filterPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__